import { stringify } from 'qs';
import request from '../request';
import { url } from '../service-utils';

/**
 * 会议室
 * 陈陈
 */
export async function getMeetingRoomUseList(params) {
  return request(`${url.meetingSign}/meeting/room/use_list?${stringify(params)}`);
}

/**
 * 发布人
 * 陈陈
 */
export async function initiatorName(params) {
  return request(`${url.meetingSign}/meeting/info/initiatorName?${stringify(params)}`);
}

/**
 * 新建签到墙
 * 陈陈
 */
export function addSignWall(params) {
  return request('', {
    url: `${url.meetingSign}/meeting/signwall/add`,
    data: params,
    method: 'post',
  });
}

/**
 * 修改签到墙
 * 陈陈
 */
export function modifySignWall(params) {
  return request('', {
    url: `${url.meetingSign}/meeting/signwall/modify`,
    data: params,
    method: 'post',
  });
}

/**
 * 获取签到墙
 * 陈陈
 */
export function getSignWall(params) {
  return request(`${url.meetingSign}/meeting/signwall/get?${stringify(params)}`);
}

/**
 * 会议记录人列表
 * 陈陈
 */
export function getMinutes(params) {
  return request(`${url.meetingSign}/meeting/info/getminutes?${stringify(params)}`);
}

/**
 * 新建会议
 * 陈陈
 */
export function addMeeting(params) {
  return request('', {
    url: `${url.meetingSign}/meeting/info/add`,
    data: params,
    method: 'post',
  });
}

/**
 * 会议详情
 * 陈陈
 */
export function getMeetingInfo(params) {
  return request(`${url.meetingSign}/meeting/info/get?${stringify(params)}`);
}

/**
 * 取消会议
 * 陈陈
 */
export function meetingCancel(params) {
  return request(`${url.meetingSign}/meeting/info/cancel?${stringify(params)}`);
}
